import { render, staticRenderFns } from "./updatePropertyDialog.vue?vue&type=template&id=85c6f2c0&scoped=true"
import script from "./updatePropertyDialog.vue?vue&type=script&lang=js"
export * from "./updatePropertyDialog.vue?vue&type=script&lang=js"
import style0 from "./updatePropertyDialog.vue?vue&type=style&index=0&id=85c6f2c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6f2c0",
  null
  
)

export default component.exports